import React from 'react';
import {Form, Header} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
  InlineDateBoxField,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import _ from 'lodash';

class BulkTaskFilter extends React.Component {
  setFilter = (name, value) => {
    const filtersAsEntered = _.cloneDeep(this.props.filtersAsEntered);
    filtersAsEntered[name] = value;
    this.props.onFilterChange(filtersAsEntered);
  };

  getBoolean = (value) => {
    switch (value) {
      case false:
      case 'false':
        return false;
      case true:
      case 'true':
        return true;
      default:
        return '';
    }
  };

  setFollowUpFilter = (name, value) => {
    value = this.getBoolean(value);
    this.setFilter(name, value);
  };

  clearAllFilters = () => {
    this.props.onFilterClear();
  };

  render() {
    const {config, sortOptions} = this.props;
    const filtersAsEntered = _.get(this.props, 'filtersAsEntered', {});
    const sortBy = _.chain(config)
      .get(['sortBy'], [])
      .reduce((result, col) => {
        result.push({
          key: col.key,
          text: col.label,
          value: col.key,
          type: col.type ? col.type : 'string',
        });
        return result;
      }, [])
      .value();
    const filtered = _.filter(this.props.assigneeList, function (el) {
      return el != null;
    });

    const sortType = (selectedValue) => {
      let selectedItem = _.find(sortBy, (item) => {
        return item.key === selectedValue;
      });
      return selectedItem.type;
    };

    const assigneeOptions = _.concat(
      [{key: 0, value: '', text: ''}],
      [{key: 'unassigned', value: 'unassigned', text: 'unassigned'}],
      _.map(_.sortBy(_.values(filtered)), (item) => ({
        key: item,
        value: item,
        text: _.get(
          _.find(this.props.userObjs, (user) => user.userId === item),
          'emailAdr',
          'Unknown Email'
        ),
      }))
    );

    const search = _.map(config.filters, (filterKey) => {
      if (filterKey === 'dateInQueue')
        return (
          <React.Fragment>
            <Header as="h5">Date in queue</Header>
            <Form.Group widths="equal">
              <InlineDateBoxField
                title="From date in queue"
                label="From date"
                id="createdAfter"
                name="createdAfter"
                value={filtersAsEntered.createdAfter}
                handleChange={(e, data) => this.setFilter(e.target.name, data.value)}
                placeholder="yyyy-mm-dd"
              />
              <InlineDateBoxField
                title="To date in queue"
                label="To date"
                id="createdBefore"
                name="createdBefore"
                value={filtersAsEntered.createdBefore}
                handleChange={(e, data) => this.setFilter(e.target.name, data.value)}
                placeholder="yyyy-mm-dd"
              />
            </Form.Group>
          </React.Fragment>
        );
      else
        return (
          <TextBoxField
            key={filterKey.name}
            title={filterKey.title}
            value={filtersAsEntered[filterKey.name]}
            name={filterKey.name}
            label={filterKey.label}
            id={filterKey.name}
            handleChange={(e) => {
              this.setFilter(e.target.name, e.target.value);
            }}
          />
        );
    });

    const enumeratedFilters = _.map(config.enumeratedFilters, (filterKey) => {
      if (filterKey === 'assignee' || 'assignee' === filterKey.name)
        return (
          <InlineSelect
            key="assigneeFilterField"
            placeholder=""
            id="assignee"
            label="Assigned to"
            search
            selection
            title="assignee"
            name="assignee"
            value={filtersAsEntered.assignee}
            handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
            options={assigneeOptions}
          />
        );
      else if (filterKey === 'followUpRequired')
        return (
          <InlineSelect
            placeholder=""
            id="followUpRequired"
            label="Flagged for follow-up"
            labeled="true"
            search
            selection
            title="followUpRequired"
            name="followUpRequired"
            value={filtersAsEntered.followUpRequired}
            handleChange={(e) => this.setFollowUpFilter(e.target.name, e.target.value)}
            options={[
              {key: '', value: null, text: ''},
              {key: 'flagged', text: 'Flagged for follow-up', value: true},
              {
                key: 'notFlagged',
                text: 'Not flagged for follow-up',
                value: false,
              },
            ]}
          />
        );
      else {
        let optionValue = [{key: '', value: null, text: ''}];
        _.forEach(_.find(this.props.variableValues, filterKey.name), (varValues) => {
          _.forEach(varValues, (varValue) => {
            optionValue.push({
              key: varValue,
              value: varValue,
              text: varValue,
            });
          });
        });

        return (
          <InlineSelect
            key={filterKey.name}
            placeholder={filterKey.placeholder}
            id={filterKey.name}
            label={filterKey.label}
            selection
            title={filterKey.title}
            name={filterKey.name}
            value={filtersAsEntered[filterKey.name]}
            handleChange={(e) => {
              this.setFilter(e.target.name, e.target.value);
            }}
            options={optionValue}
          />
        );
      }
    });

    // Make sure sortOptions matching list of columns
    var sortByValue = sortOptions.sortBy;
    if (
      !_.isEmpty(sortOptions) &&
      _.isEmpty(
        _.find(sortBy, (item) => {
          return item.key === sortOptions.sortBy;
        })
      )
    ) {
      sortByValue = _.get(sortBy, 0, {}).key;
    }

    return (
      <Form>
        <Header as="h6" textAlign="right">
          <a href="#" className="table-link" tabIndex="0" onClick={this.clearAllFilters}>
            Clear Filters
          </a>
        </Header>
        <Header as="h3">Search</Header>
        {search}
        <Header as="h3">Filters</Header>
        {enumeratedFilters}
        <Header as="h3">Sort</Header>
        <InlineSelect
          placeholder="Sort by"
          search
          selection
          title="Sort"
          value={sortByValue}
          name="sortBy"
          id="sortBy"
          label="Sort by"
          handleChange={(e) => {
            this.props.setSortBy(e.target.value, sortType(e.target.value));
          }}
          options={sortBy}
        />
        <Form.Field>
          <RadioField
            name="sortOrder"
            handleChange={(e) => {
              this.props.setSortOrder(e.target.value);
            }}
            value={sortOptions.sortOrder}
            options={[
              {label: 'Ascending (A-Z)', value: 'asc'},
              {label: 'Descending (Z-A)', value: 'desc'},
            ]}
          />
        </Form.Field>
      </Form>
    );
  }
}

export default BulkTaskFilter;
